<template>
  <div class="userinfo">
    <img v-if="picture" class = "btn-squared user" :src="picture" />
    <img v-else class = "btn-squared user" src="/static/img/student.png" />
  </div>
</template>

<script>
export default {
  name: 'UserIcon',
  props: {
    picture: String
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";
.user {
  background: white;
  padding: 2px;
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserIcon.vue